<template>
    <div>
        <!--    <div class="pure_top"></div>-->
        <div class="wrapper cust">
            <video autoplay loop muted playsinline style="width: 100%;">
                <source src="@/assets/images/automotive.mp4" type="video/mp4">
            </video>
            <!--      <h1>{{ $t("utils.mall") }}</h1>-->
            <van-tabs v-if="notAllowStopList.length > 0" v-model="active">
                <van-tab>
                    <template #title>
                        <div style="display: inline-flex; align-items: center;">
                            <van-badge>
                                <van-icon name="hot" color="#ee0a24" size="26" class="icon-shake"
                                          style="margin-right: 4px;"/>
                            </van-badge>
                            <span>{{$t('F Series')}}</span>
                        </div>
                    </template>
                    <div class="mt-20"></div>
                    <div v-for="i in notAllowStopList" class="item" :key="i.id">
                        <h3>{{ i[lang] }}</h3>
                        <div class="preview">
                            <img :src="i.img" style="width: 150px"/>
                            <div class="text-right" style="display: flex;flex-direction: column;align-items: flex-end">
                                <!--                <button v-if="!i.is_allow_stop" @click="activate(i.id)" type="button" class="invest">-->
                                <!--                  {{ $t("Activate") }}-->
                                <!--                </button>-->
                                <button @click="lease(i.id)" type="button" class="invest mt-10">
                                    {{ $t("Lease") }}
                                </button>
                            </div>
                        </div>
                        <div class="data">
                            <div class="data_rate flex">
                                <p>{{ $t("utils.income") }}</p>
                                <p>{{ i.rate }}</p>
                            </div>
                            <div class="data_day flex mt-10">
                                <p>{{ $t("Lease Term") }}</p>
                                <p>{{ i.day }}{{ $t("utils.day") }}</p>
                            </div>
                            <div class="data_min flex mt-10">
                                <p>{{ $t("Rent Payable") }}</p>
                                <p>{{ $t("currency") }}{{ i.min }}</p>
                            </div>
                        </div>
                    </div>
                </van-tab>
                <van-tab :title="$t('L Series')">
                    <div class="mt-20"></div>
                    <div v-for="i in allowStopList" class="item" :key="i.id">
                        <h3>{{ i[lang] }}</h3>
                        <div class="preview">
                            <img :src="i.img" style="width: 150px"/>
                            <div class="text-right" style="display: flex;flex-direction: column;align-items: flex-end">
                                <!--                <button v-if="!i.is_allow_stop" @click="activate(i.id)" type="button" class="invest">-->
                                <!--                  {{ $t("Activate") }}-->
                                <!--                </button>-->
                                <button @click="lease(i.id)" type="button" class="invest mt-10">
                                    {{ $t("Lease") }}
                                </button>
                            </div>
                        </div>
                        <div class="data">
                            <div class="data_rate flex">
                                <p>{{ $t("utils.income") }}</p>
                                <p>{{ i.rate }}</p>
                            </div>
                            <div class="data_day flex mt-10">
                                <p>{{ $t("Lease Term") }}</p>
                                <p>{{ i.day }}{{ $t("utils.day") }}</p>
                            </div>
                            <div class="data_min flex mt-10">
                                <p>{{ $t("Rent Payable") }}</p>
                                <p>{{ $t("currency") }}{{ i.min }}</p>
                            </div>
                        </div>
                    </div>
                </van-tab>


                <!-- new add -->
                <van-tab :title="$t('New')">
                    <div class="mt-20"></div>
                    <div v-if="threeList.length > 0">
                        <div v-for="i in threeList" class="item" :key="i.id">
                            <h3>{{ i[lang] }}</h3>
                            <div class="preview">
                                <img :src="i.img" style="width: 150px"/>
                                <div class="text-right" style="display: flex;flex-direction: column;align-items: flex-end">
                                    <button v-if="i.is_activate == 1" @click="activate(i.id)" type="button" class="invest">
                                        {{ $t("Activate") }}
                                    </button>
                                    <button v-else @click="lease(i.id)" type="button" class="invest mt-10">
                                        {{ $t("Lease") }}
                                    </button>
                                </div>
                            </div>
                            <div class="data">
                                <div class="data_rate flex">
                                    <p>{{ $t("utils.income") }}</p>
                                    <p>{{ i.rate }}</p>
                                </div>
                                <div class="data_day flex mt-10">
                                    <p>{{ $t("Lease Term") }}</p>
                                    <p>{{ i.day }}{{ $t("utils.day") }}</p>
                                </div>
                                <div class="data_min flex mt-10">
                                    <p>{{ $t("Rent Payable") }}</p>
                                    <p>{{ $t("currency") }}{{ i.min }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <van-empty  v-else
                            class="custom-image"
                                :image="require('@/assets/images/custom-empty-image.png')"
                            :description="$t('Coming soon')"
                    />
                </van-tab>
            </van-tabs>
            <div v-else class="mt-20">
                <div v-for="i in data.list" class="item" :key="i.id">
                    <h3>{{ i[lang] }}</h3>
                    <div class="preview">
                        <img :src="i.img" style="width: 150px"/>
                        <div class="text-right" style="display: flex;flex-direction: column;align-items: flex-end">
                            <!--              <button v-if="!i.is_allow_stop" @click="activate(i.id)" type="button" class="invest">-->
                            <!--                {{ $t("Activate") }}-->
                            <!--              </button>-->
                            <button @click="lease(i.id)" type="button" class="invest mt-10">
                                {{ $t("Lease") }}
                            </button>
                        </div>
                    </div>
                    <div class="data">
                        <div class="data_rate flex">
                            <p>{{ $t("utils.income") }}</p>
                            <p>{{ i.rate }}</p>
                        </div>
                        <div class="data_day flex mt-10">
                            <p>{{ $t("Lease Term") }}</p>
                            <p>{{ i.day }}{{ $t("utils.day") }}</p>
                        </div>
                        <div class="data_min flex mt-10">
                            <p>{{ $t("Rent Payable") }}</p>
                            <p>{{ $t("currency") }}{{ i.min }}</p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
    import Fetch from "../../utils/fetch";
    import Api from "../../interface/index";
    import Vue from "vue";
    import {Tab, Tabs, Progress, Empty, Dialog, Field} from "vant";

    Vue.use(Tab).use(Tabs).use(Progress).use(Empty).use(Dialog).use(Field);
    export default {
        name: "item",
        data() {
            return {
                lang: this.$i18n.locale || "en_us",
                tabs: [
                    this.$t("item.all"),
                    this.$t("item.tab1"),
                    this.$t("item.tab2"),
                    this.$t("item.tab3"),
                    this.$t("item.tab4"),
                    this.$t("item.tab5"),
                ],
                active: 0,
                nofinsh: 0,
                data: [],
                listLength: 0,
                show_tz: false,
                number: "",
                sku: [],
                computed: undefined,
                notAllowStopList: [],
                allowStopList: [],
                threeList: [],
            };
        },
        created() {
            this.$parent.footer("item");
        },
        mounted() {
            var type = 0;
            if (this.$router.history.current.query.type) {
                this.active = parseInt(this.$router.history.current.query.type);
                type = this.$router.history.current.query.type;
            }
            this.start(type);
        },
        methods: {
            start(type) {
                Fetch("/index/item_search", {
                    name: "",
                    index_type: type,
                }).then((r) => {
                    this.data = r.data;
                    if (r.data.nofinish)
                        this.nofinsh = r.data.nofinish;
                    this.listLength = r.data.list.length;

                    const list = r.data.list || [];
                    // 根据 is_allow_stop 分组
                    // this.notAllowStopList = list.filter(item => item.is_current === 0);
                    // this.allowStopList = list.filter(item => item.is_current === 1);

                    this.notAllowStopList = list.filter(item => item.index_type === 2);
                    this.allowStopList = list.filter(item => item.index_type === 1);
                    this.threeList = list.filter(item => item.index_type === 3);
                });
            },
            sort(type) {
                this.start(type);
            },
            buy(item) {
                this.sku = item;
                this.show_tz = true;
            },
            confirm() {
                if (!this.number) {
                    this.$toast(this.$t("item.inputAmount"));
                    return false;
                }
                Fetch("/index/item_apply", {
                    id: this.sku.id,
                    money: this.number,
                })
                    .then((r) => {
                        this.$router.push("/order");
                    })
                    .catch((err) => {
                        // this.psd_val = '';
                    });
            },
            // 激活产品
            activate(id) {
                Fetch("/index/activate", {
                    id: id,
                }).then(r => {
                    console.log(r);
                    this.$toast('Activation successful');
                }).catch(err => {
                    console.log(err);
                });
            },
            // 购买产品
            lease(id) {
                Fetch("/index/checkLease", {
                    id: id,
                }).then(r => {
                    console.log(r);
                    this.$router.push('/item/' + id);
                }).catch(err => {
                    console.log(err);
                });
            }
        },
    };
</script>

<style lang="less" scoped>
    #app {
        position: relative
    }

    .wrapper {
        position: absolute;
        width: 100%;
        /*top: 5%;*/
        padding-bottom: 70px;
    }

    h1 {
        font-size: 28px;
        color: #000;
        text-align: center;
        margin-bottom: 50px;
    }

    .pure_top {
        width: 100%;
        height: 300px;
        position: relative;
        z-index: 0;
        overflow: hidden;
        background: url("~@/assets/images/bg1.jpg");
        background-size: cover;
    }

    .item {
        width: 90%;
        margin: 0 auto;
        background-color: #ffffff;
        border-radius: 10px;
        margin-bottom: 15px;
        padding-bottom: 10px;
        box-shadow: 2px 2px 4px #d3d3d3;

        h3 {
            text-align: center;
            font-size: 18px;
            padding: 15px 0;
            border-bottom: 1px solid #cdcdcd;
        }
    }

    .preview {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 15px 0;
        width: 87%;
        margin: 0 auto;
        border-bottom: 1px solid #cdcdcd;

        .invest {
            background-color: #76b900;
            color: #000;
            border-radius: 5px;
            padding: 10px 15px;
            text-align: center;
            font-size: 14px;
        }
    }

    .data {
        /*display: flex;*/
        align-items: center;
        justify-content: space-between;
        padding: 15px 0;
        width: 87%;
        margin: 0 auto;

        > div {
            text-align: left;
            display: flex;
            justify-content: space-between;
            align-items: center;

            > p:first-child {
                color: #82817f;
                font-size: 14px;
            }

            > p:last-child {
                font-size: 16px;
                color: #191f19;
                font-weight: bold;
            }
        }
    }

    .progress {
        width: 85%;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .van-progress {
            background-color: #686868;
        }

        .tag {
            color: #47b897;
            background-color: #656565;
            padding: 5px 8px;
            border-radius: 10px;
        }
    }

    .icon-bounce {
        animation: bounce 1s ease-in-out infinite;
    }

    @keyframes bounce {
        0%, 100% {
            transform: translateY(0);
        }
        50% {
            transform: translateY(-3px);
        }
    }

    .icon-blink {
        animation: blink 1.2s ease-in-out infinite;
    }

    @keyframes blink {
        0%, 100% {
            opacity: 1;
        }
        50% {
            opacity: 0.3;
        }
    }

    .icon-shake {
        animation: shake 0.4s ease-in-out infinite;
    }

    @keyframes shake {
        0%, 100% {
            transform: rotate(0deg);
        }
        25% {
            transform: rotate(10deg);
        }
        75% {
            transform: rotate(-10deg);
        }
    }
</style>
